import PageHeader from 'front-end/src/components/common/page/header/PageHeader'
import { t, Trans } from '@lingui/macro'
import { Link } from 'react-router-dom'
import { Page } from 'front-end/src/components/common/page/Page'
import React from 'react'

export const NotFoundPage = () => (
  <Page>
    <PageHeader
      title={t`Page not found`}
      className="NotFoundPage__header"
      showBackButton={false}
    />
    <br />
    <Trans>
      Go back to <Link to="/dashboard">dashboard</Link>.
    </Trans>
  </Page>
)
